var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTao({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1167_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5466 38C41.5135 38 35 44.5135 35 52.5466H67.3942V108.722C66.9751 121.805 85.0001 127.061 93.4241 119.544C93.4241 119.544 83.541 120.414 83.541 107.714C83.541 95.0134 83.541 68.3588 83.541 68.3588C83.541 60.5635 78.019 54.0621 70.6712 52.5466H100.345C108.378 52.5466 114.891 46.0331 114.891 38H49.5466Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1167_356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTao);
export default __webpack_public_path__ + "static/media/tao.7583a32cf12eb7cd5e3c1389805458dc.svg";
export { ForwardRef as ReactComponent };